import * as React from 'react';

import type { GetAdminUserProfilesQueryResult } from './AdminUserProfilesProvider';
import AdminUserProfilesProvider from './AdminUserProfilesProvider';

export interface AdminUserProfilesDataContext {
  email: string | null | undefined;
  fullName: string | null | undefined;
  profilePicture: string | null | undefined;
  timezoneName: string | null | undefined;
  adminUserProfilesGql?: GetAdminUserProfilesQueryResult;
}

const INITIAL_CONTEXT_DATA: AdminUserProfilesDataContext = {
  email: null,
  fullName: null,
  profilePicture: null,
  timezoneName: null,
};

/** exported for testing purposes only, do not use in actual code */
export const adminUserProfilesDataContext = React.createContext<AdminUserProfilesDataContext>(INITIAL_CONTEXT_DATA);

export type UseAdminUserProfilesData = () => AdminUserProfilesDataContext;

export const useAdminUserProfilesData: UseAdminUserProfilesData = () => React.useContext(adminUserProfilesDataContext);

interface Props {
  userId: string | number;
}

export const AdminUserProfilesData: React.LegacyFunctionComponentWithChildren<Props> = ({ userId, children }) => {
  const { Provider } = adminUserProfilesDataContext;
  return (
    <AdminUserProfilesProvider userId={`${userId}`}>
      {(adminUserProfilesResponse) => {
        const { email, fullName, profilePicture, timezoneName } = adminUserProfilesResponse.data?.AdminUserProfiles
          ?.queryByUser ?? {
          email: null,
          fullName: null,
          profilePicture: null,
          timezoneName: null,
        };
        return (
          <Provider
            value={{ email, fullName, profilePicture, timezoneName, adminUserProfilesGql: adminUserProfilesResponse }}
          >
            {children}
          </Provider>
        );
      }}
    </AdminUserProfilesProvider>
  );
};
